import { render, staticRenderFns } from "./MagicBanner.vue?vue&type=template&id=41d05fd9&scoped=true&"
import script from "./MagicBanner.vue?vue&type=script&lang=js&"
export * from "./MagicBanner.vue?vue&type=script&lang=js&"
import style0 from "./MagicBanner.vue?vue&type=style&index=0&id=41d05fd9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d05fd9",
  null
  
)

export default component.exports